<template>
  <div class="py-3">
    <hr style="height: 1px; width: 100%">
  </div>
</template>

<script>
export default {};
</script>